import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  messageMedia: {
    objectFit: 'cover',
    width: '100%',
    height: 200,
    borderRadius: 10,
    // padding: '0 4px'
  },

  messageMediaSticker: {
    width: 200,
    height: 200
  },

  messageMediaDeleted: {
    filter: 'grayscale(1)',
    opacity: 0.4,
    marginLeft: 4
  }
}))
